import React, { useState } from "react";
import BreadCrumb from "../../../Common/BreadCrumb";
import { alertdata } from "../../../Common/data";

const AllAlert = () => {
  const useAlertState = (initialState: any) => {
    const [alertData, setAlertData] = useState(initialState);

    const handleClose = (alertId: any) => {
      setAlertData((prevAlerts: any) =>
        prevAlerts.map((alert: any) =>
          alert.id === alertId ? { ...alert, show: false } : alert
        )
      );
    };

    return [alertData, handleClose];
  };

  const [isAlert, handleAlertClose] = useAlertState(alertdata);
  const [isOutline, handleOutlineClose] = useAlertState(alertdata);
  const [isBorder, handleBorderClose] = useAlertState(alertdata);
  const [isIcon, handleIconClose] = useAlertState(alertdata);
  const [isContent, handleContentClose] = useAlertState(alertdata);
  const [isExample, handleExampleClose] = useAlertState(alertdata);

  return (
    <React.Fragment>
      <BreadCrumb title="Alerts" pageType="Elements" />
      <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {/* Basic */}
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Basic Alert
            </h2>
            <div className="grid grid-cols-1 gap-5">
              <div className="p-3 rounded bg-purple/20 text-purple">
                A simple primary alert—check it out!
              </div>
              <div className="p-3 rounded bg-muted/20 text-muted">
                A simple Secondary alert—check it out!
              </div>
              <div className="p-3 rounded bg-info/20 text-info">
                A simple Info alert—check it out!
              </div>
              <div className="p-3 rounded bg-success/20 text-success">
                A simple Success alert—check it out!
              </div>
              <div className="p-3 rounded bg-warning/20 text-warning">
                A simple Warning alert—check it out!
              </div>
              <div className="p-3 rounded bg-danger/20 text-danger">
                A simple Danger alert—check it out!
              </div>
              <div className="p-3 text-black rounded bg-black/20 dark:bg-white/5 dark:text-white">
                A simple black alert—check it out!
              </div>
              <div className="p-3 text-black rounded bg-light/20 dark:text-white">
                A simple light alert—check it out!
              </div>
            </div>
          </div>

          {/* Outline */}
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Outline Alert
            </h2>
            <div className="grid grid-cols-1 gap-5">
              <div className="p-3 border rounded border-purple bg-purple/10 text-purple">
                A simple primary alert—check it out!
              </div>
              <div className="p-3 border rounded border-muted bg-muted/10 text-muted">
                A simple Secondary alert—check it out!
              </div>
              <div className="p-3 border rounded border-info bg-info/10 text-info">
                A simple Info alert—check it out!
              </div>
              <div className="p-3 border rounded border-success bg-success/10 text-success">
                A simple Success alert—check it out!
              </div>
              <div className="p-3 border rounded border-warning bg-warning/10 text-warning">
                A simple Warning alert—check it out!
              </div>
              <div className="p-3 border rounded border-danger bg-danger/10 text-danger">
                A simple Danger alert—check it out!
              </div>
              <div className="p-3 text-black border border-black rounded bg-black/10 dark:bg-white/5 dark:text-white dark:border-darkborder">
                A simple black alert—check it out!
              </div>
              <div className="p-3 text-black border rounded border-light bg-light/20 dark:text-white dark:border-darklight">
                A simple light alert—check it out!
              </div>
            </div>
          </div>

          {/* Close Button */}
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Alert with Close button
            </h2>
            <div className="grid grid-cols-1 gap-5">
              {isAlert.map(
                (alert: any) =>
                  alert.show && (
                    <div
                      key={alert.id}
                      className={`flex items-center gap-2 p-3 text-white rounded bg-${alert.type}`}
                    >
                      <span>{alert.message}</span>
                      <button
                        type="button"
                        onClick={() => handleAlertClose(alert.id)}
                        className="transition-all duration-300 rotate-0 ltr:ml-auto rtl:mr-auto hover:opacity-80 hover:rotate-180"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          className="w-5 h-5"
                        >
                          <path
                            d="M12.0007 10.5865L16.9504 5.63672L18.3646 7.05093L13.4149 12.0007L18.3646 16.9504L16.9504 18.3646L12.0007 13.4149L7.05093 18.3646L5.63672 16.9504L10.5865 12.0007L5.63672 7.05093L7.05093 5.63672L12.0007 10.5865Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </button>
                    </div>
                  )
              )}
            </div>
          </div>

          {/* Outline Alert With Close Button */}
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Outline Alert with Close button
            </h2>
            <div className="grid grid-cols-1 gap-5">
              {isOutline.map(
                (alert: any) =>
                  alert.show && (
                    <div
                      className={`flex items-center gap-2 p-3 border rounded border-${alert.type} bg-${alert.type}/10 text-${alert.type}`}
                      key={alert.id}
                    >
                      <span>{alert.message}</span>
                      <button
                        type="button"
                        onClick={() => handleOutlineClose(alert.id)}
                        className="transition-all duration-300 rotate-0 ltr:ml-auto rtl:mr-auto hover:opacity-80 hover:rotate-180"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          className="w-5 h-5"
                        >
                          <path
                            d="M12.0007 10.5865L16.9504 5.63672L18.3646 7.05093L13.4149 12.0007L18.3646 16.9504L16.9504 18.3646L12.0007 13.4149L7.05093 18.3646L5.63672 16.9504L10.5865 12.0007L5.63672 7.05093L7.05093 5.63672L12.0007 10.5865Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </button>
                    </div>
                  )
              )}
            </div>
          </div>

          {/* Alert With Accent Border */}
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Alert with accent border
            </h2>
            <div className="grid grid-cols-1 gap-5">
              {isBorder.map(
                (alert: any) =>
                  alert.show && (
                    <div key={alert.id}
                      className={`flex items-center gap-2 p-3 border-l-4 border-${alert.type} bg-${alert.type}/10 text-${alert.type}`}
                    >
                      <span>{alert.message}</span>
                      <button
                        type="button"
                        onClick={() => handleBorderClose(alert.id)}
                        className="transition-all duration-300 rotate-0 ltr:ml-auto rtl:mr-auto hover:opacity-80 hover:rotate-180"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          className="w-5 h-5"
                        >
                          <path
                            d="M12.0007 10.5865L16.9504 5.63672L18.3646 7.05093L13.4149 12.0007L18.3646 16.9504L16.9504 18.3646L12.0007 13.4149L7.05093 18.3646L5.63672 16.9504L10.5865 12.0007L5.63672 7.05093L7.05093 5.63672L12.0007 10.5865Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </button>
                    </div>
                  )
              )}
            </div>
          </div>

          {/* Alert With Icons */}
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Alert with Icons
            </h2>
            <div className="grid grid-cols-1 gap-5">
              {isIcon.map(
                (alert: any) =>
                  alert.show && (
                    <div key={alert.id}
                      className={`flex items-center gap-2 p-3 border rounded border-${alert.type} bg-${alert.type}/10 text-${alert.type}`}
                    >
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          className="w-5 h-5"
                        >
                          <path d={alert.icon} fill="currentColor"></path>
                        </svg>
                      </span>
                      <span>{alert.message}</span>
                      <button
                        type="button"
                        onClick={() => handleIconClose(alert.id)}
                        className="transition-all duration-300 rotate-0 ltr:ml-auto rtl:mr-auto hover:opacity-80 hover:rotate-180"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          className="w-5 h-5"
                        >
                          <path
                            d="M12.0007 10.5865L16.9504 5.63672L18.3646 7.05093L13.4149 12.0007L18.3646 16.9504L16.9504 18.3646L12.0007 13.4149L7.05093 18.3646L5.63672 16.9504L10.5865 12.0007L5.63672 7.05093L7.05093 5.63672L12.0007 10.5865Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </button>
                    </div>
                  )
              )}
            </div>
          </div>

          {/* Alert Additional Content */}
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Alert Additional content
            </h2>
            <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
              {isContent.map(
                (alert: any) =>
                  alert.show && (
                    <div key={alert.id}
                      className={`p-3 border rounded border-${alert.type} bg-${alert.type}/10 text-${alert.type}`}
                    >
                      <div className="flex items-center gap-2">
                        <span className="text-lg">{alert.message}</span>
                        <button
                          type="button"
                          onClick={() => handleContentClose(alert.id)}
                          className="transition-all duration-300 rotate-0 ltr:ml-auto rtl:mr-auto hover:opacity-80 hover:rotate-180"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            className="w-5 h-5"
                          >
                            <path
                              d="M12.0007 10.5865L16.9504 5.63672L18.3646 7.05093L13.4149 12.0007L18.3646 16.9504L16.9504 18.3646L12.0007 13.4149L7.05093 18.3646L5.63672 16.9504L10.5865 12.0007L5.63672 7.05093L7.05093 5.63672L12.0007 10.5865Z"
                              fill="currentColor"
                            ></path>
                          </svg>
                        </button>
                      </div>
                      <p className="mt-1">
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s
                      </p>
                    </div>
                  )
              )}
            </div>
          </div>

          {/* Alert Examples */}
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Alert Examples
            </h2>
            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4">
              {isExample.map(
                (alert: any) =>
                  alert.show && (
                    <div key={alert.id}
                      className={`relative p-4 text-center border rounded border-${alert.type} bg-${alert.type}/10 text-${alert.type}`}
                    >
                      <button
                        type="button"
                        onClick={() => handleExampleClose(alert.id)}
                        className="absolute transition-all duration-300 rotate-0 ltr:right-2 rtl:left-2 top-2 hover:opacity-80 hover:rotate-180"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          className="w-5 h-5"
                        >
                          <path
                            d="M12.0007 10.5865L16.9504 5.63672L18.3646 7.05093L13.4149 12.0007L18.3646 16.9504L16.9504 18.3646L12.0007 13.4149L7.05093 18.3646L5.63672 16.9504L10.5865 12.0007L5.63672 7.05093L7.05093 5.63672L12.0007 10.5865Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </button>
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          className="w-12 h-12 mx-auto"
                        >
                          <path d={alert.icon} fill="currentColor"></path>
                        </svg>
                      </span>
                      <p className="mt-3 text-lg">Primary alert</p>
                      <p className="mt-2">Lorem Ipsum is simply dummy text.</p>
                    </div>
                  )
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AllAlert;
